import React from 'react';
import CartSummaryDetails from '../cartSummaryDetails';
import PaymentForm from '../paymentForm';
import './paymentPage.scss';

const PaymentPage = () => {
    return (
        <div className="payment-page-container">
            <div className="pay-form-anim">
                <PaymentForm />
            </div>
            <div className="payment-summary-container">
                <CartSummaryDetails />
            </div>
        </div>
    );
};

export default PaymentPage;
